export const getCoteRotieData = () => ({
  name: "Côte-Rôtie",
  region: "Rhône",
  country: "France",
  description: "Côte-Rôtie est l'une des appellations les plus prestigieuses du Rhône septentrional, produisant des vins rouges élégants et complexes avec le cépage Syrah et parfois du Viognier.",
  type: "subregion",
  area: "300 ha",
  production: "15,000 hectolitres",
  mapAreas: [
    { region: "Côte-Rôtie", x: 54, y: 64, color: "#4B164C", size: 4 }
  ],
  characteristics: {
    climate: "Climat continental avec influence méditerranéenne",
    soil: "Sols de granit, schiste et micaschiste",
    viticulture: "Viticulture en terrasses, vendanges manuelles, rendements très limités"
  },
  wineStyles: {
    red: "Vins rouges élégants et complexes, avec des notes de violette et d'épices"
  },
  history: "Côte-Rôtie produit des vins depuis l'époque romaine. L'appellation est reconnue depuis 1940. Les vignes sont plantées sur des terrasses escarpées, d'où le nom 'Côte-Rôtie' (côte rôtie).",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine gastronomique",
  grapeVarieties: [
    {
      name: "Syrah",
      percentage: "95%",
      description: "Cépage principal de Côte-Rôtie, produisant des vins élégants et complexes",
      characteristics: "Élégant, complexe, tanins soyeux, notes de violette et d'épices",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Viognier",
      percentage: "5%",
      description: "Cépage d'assemblage autorisé, apportant aromatique et élégance",
      characteristics: "Aromatique, élégant, notes de fleurs blanches et d'abricot",
      wineStyles: "Sec, léger, aromatique"
    }
  ]
}); 